import Joyride from 'react-joyride'

import type { ReactElement } from 'react'
import type { CallBackProps, Step } from 'react-joyride'

interface Props {
  continuous?: boolean
  disableCloseOnEsc?: boolean
  featureKey: string
  showProgress?: boolean
  showSkipButton?: boolean
  steps: Step[]
}

const Onboarding = ({
  continuous,
  disableCloseOnEsc,
  featureKey,
  showProgress,
  showSkipButton,
  steps,
}: Props): ReactElement | null => {
  const hasBeenOnboard = localStorage.getItem(featureKey) === 'true'

  const handleCallback = (state: CallBackProps) => {
    switch (state.action) {
      case 'close':
      case 'skip':
        localStorage.setItem(featureKey, 'true')
        break
      case 'next':
        if (state.type === 'tour:end') localStorage.setItem(featureKey, 'true')
        break
      default:
        return
    }
  }

  return !hasBeenOnboard ? (
    <Joyride
      callback={handleCallback}
      continuous={continuous}
      disableCloseOnEsc={disableCloseOnEsc}
      disableOverlayClose
      showProgress={showProgress}
      showSkipButton={showSkipButton}
      steps={steps}
      styles={{
        tooltipContainer: {
          textAlign: 'left',
        },
      }}
    />
  ) : null
}

export default Onboarding
